import type { MerchantCurrencyCode } from "@/utils/currency"
import type { Source } from "../sharedTypes/merchants"

export type MerchantGroupMerchant = {
  id: number
  name: string
  mid: string | null
  currency: MerchantCurrencyCode
  tpReference: string | null
  transactionTotal: number
  lastTransactedAt: Date | null
  sources: Array<Source> | null
}

export type MerchantGroupAdmin = {
  email: string
}

export type RetrieveMerchantGroupResponse = {
  id: string
  name: string
  merchants: Array<MerchantGroupMerchant>
  admins: Array<MerchantGroupAdmin>
}

export const retrieveMerchantGroup = async (
  merchantGroupId: string
) => {
  const { body } =
    await api.get<RetrieveMerchantGroupResponse>(
      `/merchant-groups/${merchantGroupId}`
    )

  return body
}
